__turbopack_context__.v({
  "directionsLink": "a_kc-q_directionsLink",
  "phoneLink": "a_kc-q_phoneLink",
});
